/* DiscountCode View, Vue Component */
<template>
  <v-card v-if="entity && !loading" id="discountcode-view" class="entity-view">
      <v-card-title>View Discount Code</v-card-title>

      <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-row class="align-center pb-5">
        <v-col>

        <v-btn
          color="primary"
          class="me-3"
          :to="{ name: 'discountcode-edit', params: { id: entity.Id } }"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPencilOutline }}
          </v-icon>
          <span>Edit</span>
        </v-btn>
        </v-col>
        <v-col class="text-right">
        <v-btn
          color="secondary"
          class="me-3"
          :to="{ name: 'discountcode-create' }"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Create Discount Code</span>
        </v-btn>
        <v-btn
          color="secondary"
          class="me-3"
          :to="{ name: 'discountcode-list'}"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiViewList }}
          </v-icon>
          <span>Back</span>
        </v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-simple-table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>

      <tr>
        <td>Code</td>
        <td>{{ entity.Code }}</td>
      </tr>

      <tr>
        <td>Enabled</td>
        <td><v-icon size="18" :color="booleanIcons(entity.Enabled).variant">{{ booleanIcons(entity.Enabled).icon }}</v-icon></td>
      </tr>

      <tr>
        <td>Only Products</td>
        <td><v-icon size="18" :color="booleanIcons(entity.OnlyProducts).variant">{{ booleanIcons(entity.OnlyProducts).icon }}</v-icon></td>
      </tr>

      <tr>
        <td>Absolute Discount</td>
        <td>{{ Display.Money(entity.AbsoluteDiscount) }}</td>
      </tr>

      <tr>
        <td>Percentage Discount</td>
        <td>{{ entity.PercentageDiscount }}</td>
      </tr>

      <!-- <tr>
        <td>Single Use</td>
        <td><v-icon size="18" :color="booleanIcons(entity.SingleUse).variant">{{ booleanIcons(entity.SingleUse).icon }}</v-icon></td>
      </tr>

      <tr>
        <td>Single User Per Member</td>
        <td><v-icon size="18" :color="booleanIcons(entity.SingleUsePerMember).variant">{{ booleanIcons(entity.SingleUsePerMember).icon }}</v-icon></td>
      </tr> -->

      <tr>
        <td>Valid From</td>
        <td>{{ Display.DateTime(entity.ValidFrom) }}</td>
      </tr>

      <tr>
        <td>Valid To</td>
        <td>{{ Display.DateTime(entity.ValidTo) }}</td>
      </tr>

            <tr>
        <td>Available Uses</td>
        <td>{{ entity.Uses }}</td>
      </tr>

                  <tr>
        <td>Member</td>
        <td>{{ entity.MemberId_FullName }} - {{ entity.MemberId_Email }}</td>
      </tr>
      <!-- <tr>
        <td>Products</td>
        <td>{{ entity.ProductIds }}</td>
      </tr>

      <tr>
        <td>Order Types</td>
        <td>{{ entity.OrderTypes }}</td>
      </tr> -->

      <!-- <tr>
        <td>User Email</td>
        <td>{{ entity.UserId_Email }}</td>
      </tr> -->

      <tr>
        <td>Created</td>
        <td>{{ Display.DateTime(entity.Created) }}</td>
      </tr>

      <tr>
        <td>Updated</td>
        <td>{{ Display.DateTime(entity.Updated) }}</td>
      </tr>

      <tr>
        <td>Updated By</td>
        <td>{{ entity.UserId_FullName }}</td>
      </tr>

        </tbody>
      </v-simple-table>

  </v-card>
</template>

<script>
import store from '@/store'
import { useRouter } from '@core/utils'
import * as Display from '@/datahelpers/displayTypes'

import {
  mdiPencilOutline,
  mdiPlus,
  mdiViewList,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedOutline,
  mdiClose
} from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'

export default {
  setup() {

    const { route, router  } = useRouter();

    const entity = computed(() => store.state.app.DiscountCode);
    const loading = ref(false);

    const fetchData = (id) => {
      store
        .dispatch('app/fetchDiscountCode', {
          id: id
        })
        .then(response => {
          loading.value = false
        })
        .catch(error => {
          console.log(error);
          router.push({ name: 'discountcode-list'});
        })
    }

    // fetch the user information when params change
    //watch(() => route.value.params.id, (id) => fetchData(id));

    // and call now
    fetchData(route.value.params.id);


    const booleanIcons = status => {
      if (status) return { variant: 'success', icon: mdiCheckboxMarkedOutline }
      return { variant: 'secondary', icon: mdiCheckboxBlankOutline }
    }


    return {
      loading,
      entity,
      Display,
      booleanIcons,
      icons: {
        mdiPencilOutline,
        mdiPlus,
        mdiViewList,
        mdiClose
      },
    };
  }
}
</script>

<style lang="scss" scoped>
.entity-view::v-deep .v-data-table th:last-child {
  width: 66%;
}
</style>

